/**
 * Listas de países e idiomas já traduzidas para o idioma ativo da interface.
 *
 * Use estas listas em qualquer lugar que EXIBA o nome (seletor, chip de filtro,
 * ficha do contato). Para gravar ou casar valores continue usando as listas
 * originais: o `id` é idêntico nas duas, só o `name` muda.
 *
 * Ver shared/helpers/LocaleDisplayNames.js para o porquê da separação.
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import countries from 'shared/constants/countries';
import languages from 'dashboard/components/widgets/conversation/advancedFilterItems/languages';
import allLocales from 'shared/constants/locales';
import {
  languageName,
  localizeCountries,
  localizeLanguages,
} from 'shared/helpers/LocaleDisplayNames';

/**
 * @returns {{
 *   localizedCountries: import('vue').ComputedRef<Array<Object>>,
 *   localizedLanguages: import('vue').ComputedRef<Array<Object>>,
 *   localeName: (code: string) => string,
 * }}
 */
export function useLocalizedLists() {
  const { locale } = useI18n();

  const localizedCountries = computed(() =>
    localizeCountries(countries, locale.value)
  );

  const localizedLanguages = computed(() =>
    localizeLanguages(languages, locale.value)
  );

  /**
   * Nome de um locale do Help Center ('pt_BR', 'zh_Hant_TW') no idioma ativo.
   * @param {string} code
   * @returns {string}
   */
  const localeName = code => languageName(code, locale.value, allLocales[code]);

  return { localizedCountries, localizedLanguages, localeName };
}

export default useLocalizedLists;
